// @flow
import { Component } from "react";
import { withRouter } from "react-router-dom";

class RedirectoLogin extends Component<*> {
  componentDidMount() {
    window.location = "/login?next=" + this.props.location.pathname;
  }
  render(): * {
    return null;
  }
}

export default withRouter(RedirectoLogin);
